import * as _ from 'lodash-es';
import axios from 'axios';
import Cookies from 'js-cookie';
import initSecContext from '../data/initSecContext.js';
import { getCartCache } from '../../../utils/ecommerce/http-cart.js';
import { getRootDomain } from '../../../utils/common/url.js';

export default class ppSectionData {
	constructor(props) {
		this.initSecContext = initSecContext.getPropsContext();
		this.countryCode = '';
		this.verificationNeeded;
		this.verificationType;
		this.cardConfig = {
			isOpenByPath: {},
			isBundleByPath: {},
		};
		this.storeVariables = {};
	}

	async getCardsData(verificationNeeded, verificationType, _storeVariables) {
		this.storeVariables = _storeVariables;
		this.verificationNeeded = verificationNeeded;
		this.verificationType = verificationType;
		let requestBody = await this.setCardPayLoad();
		if ('error' in requestBody) {
			console.error('[BUY CARD ERROR: ', requestBody.error, ']');
			return requestBody.error;
		}

		// Send a POST request
		try {
			return await axios({
				method: 'post',
				url: '/bin/esri/productpricing',
				data: requestBody,
				responseType: 'json',
			}).then((res) => {
				let prodData = res.data;
				prodData.config = this.cardConfig;
				prodData.currSec = this.initSecContext.currSec;
				return prodData;
			});
		} catch (error) {
			console.error({ error });
			return { error: `catch API Error: [${error}]` };
		}
	}

	async setCardPayLoad() {
		let appWrapper = this.initSecContext.appWrapper;

		let payload = {
			verificationNeeded: this.verificationNeeded || 'false',
		};

		if (this.verificationNeeded === 'true') {
			payload.verificationType = this.verificationType;
			let params = new URLSearchParams(window.location.search.slice(1));
			let verificationId = params.get('verificationId');
			if (verificationId) {
				payload.verificationId = verificationId;
			}
		}

		if (this.countryCode == '') {
			this.countryCode = await this.getCountryCode();
			if (!this.countryCode || this.countryCode == '') {
				return {
					error: 'noCountryCode',
				};
			}
		}
		payload.country_code = this.countryCode;
		let selectedZone = this.getSelectedZone();
		if (selectedZone) {
			payload.selectedZone = selectedZone;
		}
		payload.data = [];
		if (appWrapper) {
			let paths = [].slice.call(appWrapper.querySelectorAll('[data-productpath]'));
			if (paths.length) {
				paths.forEach((path) => {
					const prodPath = path.getAttribute('data-productpath');
					// check if any card should be open onload
					const isOpen = path.getAttribute('data-isopen');
					const isBundle = path.getAttribute('data-isbundle');
					this.cardConfig.isOpenByPath[prodPath] = isOpen === 'true';
					this.cardConfig.isBundleByPath[prodPath] = isBundle === 'true';
					// end
					payload.data.push({
						contentFragment: prodPath,
						isBundle: isBundle === 'true',
					});
				});
			} else {
				console.error('No product path have been selected! Please review dialog');
			}
		}
		payload.distributor = this.getDistributorConfig();
		return payload;
	}

	getDistributorConfig() {
		const _host = location.host;

		if (`${_host}/` === '.esri.com.tr/') {
			// needs fowardslash for cases like (https://preview.esri.com.tr/tr-tr/ -- turkey)
			return true;
		}

		if (_host.indexOf('preview') > -1 || _host.indexOf('www.') > -1) {
			// FIXME this condition is always false
			if (`${_host}/` === 'preview.esri.com' || `${_host}/` === 'www.esri.com') {
				return false;
			}
			return true;
		}
		// dev and stage environments
		return false;
	}

	normalizePayload(rawPayload) {
		let _rawData = rawPayload.data;
		// remove back slashes
		let backlashRegx = /\\"/gm;
		_rawData = _rawData.replace(backlashRegx, `"`);
		// remove quotes before and after the square braquets
		let beforeQuotes = /\["{/gm;
		let afterQuotes = /}"\]/gm;
		_rawData = _rawData.replace(beforeQuotes, `[{`);
		_rawData = _rawData.replace(afterQuotes, `}]`);
		// convert href double quotes to single quotes =" and ">
		let beforeLinkQuotes = /="/gm;
		let afterLinkQuotes = /">/gm;
		_rawData = _rawData.replace(beforeLinkQuotes, `='`);
		_rawData = _rawData.replace(afterLinkQuotes, `'>`);
		// remove [end]

		rawPayload.data = JSON.parse(_rawData);
		rawPayload.config = this.cardConfig;
		return rawPayload;
	}

	getSelectedZone() {
		let selectedZone = Cookies.get('selectedZone');
		if (selectedZone) {
			return selectedZone;
		}
		return null;
	}

	async getCountryCode() {
		let countryCode = Cookies.get('omniCoutryCode');
		let cartId = Cookies.get('eCommCartId');
		if (cartId) {
			let cartZone = Cookies.get('eCartZone');
			if (cartZone) {
				countryCode = cartZone;
			} else {
				let cookieCartZone = await this.getCartData(cartId);
				countryCode = cookieCartZone ? cookieCartZone : countryCode;
			}
		}
		if (!countryCode) {
			await new Promise((resolve) => {
				setTimeout(() => {
					countryCode = Cookies.get('omniCoutryCode');
					resolve();
				}, 200);
			});
		}
		return countryCode;
	}

	async getCartData(cartId) {
		let token = this.getAuthToken();
		let cart = await getCartCache(cartId, token)
			.getData()
			.then((response) => {
				if (response.status !== 200) {
					return null;
				}
				return response.data[0];
			})
			.catch((error) => {
				console.error('getCartState error: ', error);
				return null;
			});

		if (!cart) {
			return null;
		}

		// set cartZone cookie
		let currDomain = window.location.hostname;
		let cartObj = {
			expires: 2000,
			path: '/',
			domain: getRootDomain(currDomain),
		};
		let cartZone = cart.zone;
		Cookies.set('eCartZone', cartZone, cartObj);

		return Cookies.get('eCartZone');
	}

	getAuthToken() {
		const esriAuthCookie = Cookies.get('esri_auth');
		let token = null;
		if (esriAuthCookie) {
			let parsedEsriAuthCookie = JSON.parse(decodeURIComponent(esriAuthCookie));
			token = parsedEsriAuthCookie.token;
		}
		return token;
	}
}
